module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "minitoc notoc",
    attrs: {
      "data-pdf-bookmark": "Newsletter Sign-up",
      "data-type": "preface",
      "epub:type": "preface"
    }
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "d13e18"
    }
  }, [_c('h1', {
    staticClass: "ChapTitleNonprintingctnp",
    attrs: {
      "data-displayheader": "no"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newsletter Sign-up")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('a', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/part01#d1e884",
      "id": "beginreading"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('span', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/toc01#z_TOC",
      "id": "toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('span', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/app04#d1e13998",
      "id": "abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('a', {
    staticClass: "spanhyperlinkurl",
    attrs: {
      "href": "#/copyrightpage01#d1e472",
      "id": "copyright-page"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "font-weight": "bold",
      "line-height": "1.3em",
      "margin-top": "4em"
    }
  }, [_vm._v("Thank you for buying this Tor Books ebook.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.3em"
    }
  }, [_vm._v("To receive special offers, bonus content, and info on new releases and other great reads, sign up for our newsletters.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://us.macmillan.com/newslettersignup?utm_source=ebook&utm_medium=adcard&utm_term=ebookreaders&utm_content=wildcardstrust_newslettersignup_macdotcom&utm_campaign=9780765396402",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "signup button",
      "height": "67",
      "src": "NewsletterSignup.jpg",
      "width": "112"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "line-height": "1.3em",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Or visit us online at "), _c('a', {
    attrs: {
      "href": "http://us.macmillan.com/newslettersignup?utm_source=ebook&utm_medium=adcard&utm_term=ebookreaders&utm_content=wildcardstrust_newslettersignup_macdotcom&utm_campaign=9780765396402",
      "target": "_blank"
    }
  }, [_vm._v("us.macmillan.com/newslettersignup")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-545d007c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface01.vue
// module id = 60
// module chunks = 0